import type { RenderLink } from '@ccpgames/eve-web-core'
import Link from 'next/link'

/**
 * Next.js adapter for the library `renderLink` contract.
 *
 * Rule:
 * - `external: true` → render `<a>` opening in a new tab.
 * - otherwise → render Next.js `<Link>`.
 */
export const renderLink: RenderLink = ({ href, external, children, ...props }) => {
  if (external) {
    return (
      <a href={href} {...props} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    )
  }

  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  )
}
